import { Badge } from 'react-bootstrap';
import React from 'react';
import { UserRoles } from '../../../types/user/user';
import { useTranslation } from 'react-i18next';

interface RankBadgeProps {
    role: string;
    pill: boolean;
}

export const RankBadge = ({ role, pill }: RankBadgeProps) => {
    const { t } = useTranslation();
    switch (role) {
        case UserRoles.USER:
            return <Badge className={`badge bg-secondary mr-1 font-11 ${pill ? 'badge-pill' : ''}`}>{t('badges.user_role')}</Badge>;
        case UserRoles.ADMIN:
            return <Badge className={`badge bg-danger mr-1 font-11 ${pill ? 'badge-pill' : ''}`}>{t('badges.admin_role')}</Badge>;
        case UserRoles.SUBSCRIBER:
            return <Badge className={`badge bg-yellow mr-1 font-11 ${pill ? 'badge-pill' : ''}`}>{t('badges.subscriber_role')}</Badge>;
        case UserRoles.PROFESSOR:
            return <Badge className={`badge bg-info mr-1 font-11 ${pill ? 'badge-pill' : ''}`}>{t('badges.professor_role')}</Badge>;
        default:
            return <span>No badge</span>;
    }
};
